import { render, staticRenderFns } from "./PageListItemDropHelper.vue?vue&type=template&id=4800ea07&"
import script from "./PageListItemDropHelper.vue?vue&type=script&lang=js&"
export * from "./PageListItemDropHelper.vue?vue&type=script&lang=js&"
import style0 from "./PageListItemDropHelper.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports